import { render } from "./SelectWorkspace.vue?vue&type=template&id=c3435210&scoped=true"
import script from "./SelectWorkspace.vue?vue&type=script&lang=js"
export * from "./SelectWorkspace.vue?vue&type=script&lang=js"

import "./SelectWorkspace.vue?vue&type=style&index=0&id=c3435210&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3435210"]])

export default __exports__